import { indexData } from '@/mocks/homeData';

const zoneColors: Record<string, string> = {
  '一区': 'bg-primary-100 text-primary-700',
  '二区': 'bg-accent-100 text-accent-700',
  '大赛': 'bg-secondary-100 text-secondary-700',
  '专题': 'bg-background-200 text-foreground-700',
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            {indexData.title}
          </h2>
          <p className="text-sm text-foreground-600">按分区浏览51黑料网全部专题合集</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexData.items.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-5 flex items-center gap-4 cursor-pointer hover:bg-background-100 transition-colors"
            >
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-background-200 rounded-lg">
                <i className="ri-folder-3-line text-lg text-foreground-600"></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-800 truncate">{item.name}</h3>
                <div className="flex items-center gap-2 mt-1">
                  <span className={`px-2 py-0.5 text-xs font-medium rounded ${zoneColors[item.zone] || 'bg-background-200 text-foreground-600'}`}>
                    {item.zone}
                  </span>
                  <span className="text-xs text-foreground-500">{item.count}</span>
                </div>
              </div>
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}